import { FC, ReactNode } from 'react';
import {
  cvaPopupBg,
  cvaPopupButtons,
  cvaPopupInner,
  cvaPopupText,
  cvaPopupTitle,
  cvaPopupTop,
} from './PopupStyles';
import { Button } from '~/shared/ui/Button/Button';
import { OwnBlock } from '~/shared/ui/OwnBlock/OwnBlock';
import Clear from 'public/icons/close.svg?react';
import clsx from 'clsx';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { AnimatePresence, motion } from 'framer-motion';

interface Props {
  title?: string;
  description?: string;
  button: {
    text: string;
    action?: () => void;
    href?: string;
    alertButton?: boolean;
    grayButton?: boolean;
    disabled?: boolean;
    isLoading?: boolean;
    icon?: ReactNode;
  };
  button_second?: {
    text: string;
    action?: () => void;
    href?: string;
    alertButton?: boolean;
    grayButton?: boolean;
    isLoading?: boolean;
  };
  button_third?: {
    text: string;
    action?: () => void;
    href?: string;
    alertButton?: boolean;
    grayButton?: boolean;
    isLoading?: boolean;
  };
  formPopup?: boolean;
  fields?: React.ReactNode;
  onClose?: () => void;
  open: boolean;
  className?: string;
  image?: string;
}

export const Popup: FC<Props> = ({
  title,
  description,
  button,
  button_second,
  button_third,
  formPopup,
  fields,
  onClose,
  open,
  className,
  image,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key={Number(open) + title ?? ''}
          initial={{ opacity: 0, translateY: 30 }}
          animate={{ opacity: 1, translateY: 0 }}
          exit={{ opacity: 0, translateY: 30 }}
          transition={{ ease: 'easeOut', duration: 0.3 }}
          className={cvaPopupBg({ bottom: (!formPopup || !fields) && !image })}>
          <OwnBlock
            containerClass={clsx(cvaPopupInner(), className)}
            variant="big">
            {onClose && (
              <Clear
                onClick={onClose}
                className={clsx(
                  cvaIcon({ iconSize: 'common' }),
                  'absolute right-2.4 top-2 z-[150] cursor-pointer'
                )}
              />
            )}
            {image && (
              <img
                src={image}
                alt=""
                className={'-mt-4 mb-2.6 mx-auto max-w-[26rem]'}
              />
            )}
            {(title || description) && (
              <div className={cvaPopupTop({ separated: formPopup })}>
                {title && (
                  <p
                    className={clsx(
                      cvaPopupTitle({ separated: formPopup }),
                      image && 'text-[3rem]'
                    )}
                    dangerouslySetInnerHTML={{ __html: title }}></p>
                )}
                {description && (
                  <p
                    className={cvaPopupText()}
                    dangerouslySetInnerHTML={{ __html: description }}></p>
                )}
              </div>
            )}
            {fields}
            {(!formPopup || !fields) && (
              <div className={cvaPopupButtons()}>
                <Button
                  size={'tabs'}
                  variant={
                    button.alertButton
                      ? 'red'
                      : button.grayButton
                        ? 'darkGray'
                        : 'primary'
                  }
                  onClick={() => button?.action?.()}
                  isLoading={button.isLoading}
                  icon={button.icon}
                  href={button?.href ?? undefined}>
                  {button.text}
                </Button>

                {button_second && (
                  <Button
                    size={'tabs'}
                    variant={
                      button_second.alertButton
                        ? 'red'
                        : button.grayButton
                          ? 'darkGray'
                          : 'noneBg'
                    }
                    onClick={() => button_second?.action?.()}
                    isLoading={button_second.isLoading}
                    href={button_second?.href ?? undefined}>
                    {button_second.text}
                  </Button>
                )}

                {button_third && (
                  <Button
                    size={'common'}
                    variant={null}
                    onClick={() => button_third?.action?.()}
                    isLoading={button_third.isLoading}
                    href={button_third?.href ?? undefined}>
                    {button_third.text}
                  </Button>
                )}
              </div>
            )}
          </OwnBlock>
          {formPopup && fields && (
            <OwnBlock containerClass={cvaPopupInner()} variant="big">
              <div className={cvaPopupButtons()}>
                <Button
                  disabled={button.disabled}
                  type="submit"
                  className="w-full"
                  size={'common'}
                  variant={
                    button.alertButton
                      ? 'red'
                      : button.grayButton
                        ? 'darkGray'
                        : 'primary'
                  }
                  onClick={() => button?.action?.()}
                  isLoading={button.isLoading}
                  icon={button.icon}
                  href={button?.href ?? undefined}>
                  {button.text}
                </Button>
                {button_second && (
                  <Button
                    size={'common'}
                    variant={
                      button_second.alertButton
                        ? 'red'
                        : button.grayButton
                          ? 'darkGray'
                          : 'noneBg'
                    }
                    onClick={() => button_second?.action?.()}
                    isLoading={button_second.isLoading}
                    href={button_second?.href ?? undefined}>
                    {button_second.text}
                  </Button>
                )}
              </div>
            </OwnBlock>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
